import Conjunto from "@/Components/Conjunto";
import ResponsiveAntdTable, { ResponsiveAntdTableProps } from "@/Components/ResponsiveAntdTable";
import { MovimentacaoSaldoPeriodo } from "@/Models/Domain/Relatorio/Financeiro/Conta/MovimentacaoSaldoPeriodo";
import { TypeCentroCusto } from "@/Models/Financeiro/CentroCusto";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";
import Utilitario from "@/Utils/Utilitario";
import { Button, Dropdown } from "antd";
import { Link } from "react-router-dom";

import Formatacoes from "@/Utils/Formatacao";
import { Balanco } from "@/Components/Balanco";
import Titulo, { _TituloSemRecursao, EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import MovimentacaoDesativarPopconfirm from "@/Components/Populados/Financeiro/Conta/Movimentacao/MovimentacaoDesativarPopconfirm";
import { Movimentacao } from "@/Models/Financeiro/Conta/Movimentacao";
import { OpcoesMovimentacao } from "@/Components/Populados/Financeiro/Conta/Movimentacao/MovimentacaoTableBasic";
import OpceosTitulo from "@/Components/Populados/Financeiro/Titulo/OpceosTitulo";
import { SettingOutlined } from "@ant-design/icons";

type DataIndex = Omit<MovimentacaoSaldoPeriodo, "titulo"> & { titulo: _TituloSemRecursao };

export interface ISaldoPeriodoTableBasicProps extends ResponsiveAntdTableProps<MovimentacaoSaldoPeriodo, DataIndex> {
    _plus?: {
        depoisDeDesativar?: () => any
    }
}

export default function SaldoPeriodoTableBasic({
    _plus,
    ...rest
}:ISaldoPeriodoTableBasicProps) {
    return (
        <>
            <ResponsiveAntdTable<MovimentacaoSaldoPeriodo, DataIndex>
                {...rest}
                size="small"
                showHeader={true}
                disableResponsiveness={true}
                minColWidthIfResponsivenessDisabled={"80px"}
                scroll={{
                    x : undefined,
                    y : "70vh"
                }}
                tableLayout="auto"
                //rowClassName={(record: RecordType, index: number, indent: number) => ""} 
                rowKey={(k) => k.id}
                csv={{
                    ...(rest?.csv ?? {}),
                    enabled: rest?.csv?.enabled ?? true,
                    filename: rest?.csv?.filename ?? "Extrato_Bancario.csv",
                }}
                columns={
                    [
                        {
                            key: "data",
                            title: "Data",
                            dataIndex: ["data"],
                            render: (value: Date | undefined) => value?.toLocaleDateString(),
                        },
                        {
                            key: "centro-custo",
                            title: "Centro de custo",
                            dataIndex: ["centroCusto"],
                            render: (n: TypeCentroCusto) => n?.descricao ?? '-',
                            minWidth: "200px"
                        },
                        {
                            key: "comprovante",
                            title: "Comprovante",
                            minWidth: "90px",
                            dataIndex: ["comprovante"],
                            render(value: string, record: MovimentacaoSaldoPeriodo) {
                                return (record.urlComprovante ?? "").length > 0 ? (
                                    <a rel="noopener" href={record.urlComprovante!} target="_blank">
                                        {value}
                                    </a>
                                ) : (value?.length ?? 0) > 0 ? (
                                    value
                                ) : (
                                    " - "
                                );
                            },
                        },
                        {
                            key: "pessoa",
                            title: "Pagador",
                            dataIndex: ["pessoa"],
                            render(value, _, __) {
                                return value === null || value === undefined ? "-" : extractorNomePessoa(value);
                            },
                            minWidth: "200px"
                        },
                        {
                            key: "descricao",
                            title: "Descrição",
                            dataIndex: ["descricao"],
                            render(value) {
                                return value === null || value === undefined || value.trim() === "" ? " - " : value;
                            },
                            minWidth: "200px"
                        },
                        {
                            key: "valor",
                            title: "Valor",
                            dataIndex: ["valor"],
                            render(value) {
                                return Formatacoes.formatarReal(value);
                            },
                            csv: {
                                get: (record) => Utilitario.toCSVDinheiro(record?.valor),
                                title: "Valor (R$)"
                            }
                        },
                        {
                            key: "saldo",
                            title: "Saldo",
                            dataIndex: ["saldo"],
                            render(value) {
                                return <Balanco>{Utilitario.toStringDinheiro(value)}</Balanco>; 
                            },
                            csv: {
                                get: (record) => Utilitario.toCSVDinheiro(record?.saldo),
                                title: "Saldo (R$)"
                            }
                        },
                        {
                            title: "",
                            key: "acoes",
                            csv: { ignore: true },
                            minWidth : "20px",
                            noResponsiveTitle: true,
                            fixed: "right",
                            render: (_, item) => {
                                if ((item.titulo?.codigo ?? 0) > 0 && (item.titulo?.codFatura ?? 0) <= 0)
                                    return <div>Teste</div>;

                                return ((item.titulo?.codFatura ?? 0) > 0 && (item.titulo?.codigo ?? 0) > 0) && <OpceosTitulo 
                                    titulo={{
                                        codigo : item.titulo.codigo,
                                        codFatura : item.titulo.codFatura,
                                        codSituacao : item.titulo.codSituacao,
                                        codMovimentacao : item.titulo.codMovimentacao,
                                        codTipo : item.titulo.codTipo,
                                        ativo : item.titulo.ativo
                                    } as Titulo}
                                    isDesativar={true}
                                    isAtivar={true}
                                    isPagar={true}
                                    isVisualizar={true}   
                                    isFormasPagamento={false}
                                    onSucess={() => props?._plus?.depoisDeDesativar?.()}                                         
                                >
                                    <SettingOutlined />
                                </OpceosTitulo> || <OpcoesMovimentacao 
                                    onSuccess={() => _plus?.depoisDeDesativar?.()} 
                                    pathBaseLink={"/financeiro/movimentacoes/"} 
                                    value={item.id} 
                                    record={{ codigo : item.id, codMovimentacaoBase : item.codMovimentacaoBase, codMovimentacaoFilha : item.codMovimentacaoFilha }} 
                                />;
                            }
                        }
                    ]
                }
            />
        </>
    );
}
